import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`原語でオペラを楽しもう！`}</h1>
    <p>{`オペラは基本的に原語で上演されます。昔は訳詞上演（例えばイギリスでは英語訳で）というのが一般的であった時代もあったようですが、現在ではドイツオペラならドイツ語、イタリアオペラならイタリア語というように、元の言語で上演されるのが普通です。`}</p>
    <p>{`ドイツ語やイタリア語が分からなければ字幕に頼ることになるわけですが、オペラの場合、字幕にもなかなか限界があります。`}</p>
    <p>{`例えば、重唱と言って複数の登場人物が複数の異なる内容を同時に歌うことがあります。字幕を見ても誰がどのセリフを言っているのか分からないということはよくあることです。`}</p>
    <p>{`また、原語で歌詞を理解していると、字幕で観るのとも、あらすじを覚えているからだいたい分かる、というのとも違う、別次元の感動があります。`}</p>
    <p>{`発せられる声がダイレクトに歌の意味となって頭に入ってくるのです。`}</p>
    <p>{`発声や表現などの細かいところに注目する余裕も生まれます。歌詞の単語にはそれぞれ意味があるのですから、その単語を歌手がどう表現しようとしているのか、というところも見ることができるわけです。`}</p>
    <p>{`字幕を見ていて細かい演技を見逃してしまった、なんていうこともなくなりますね！`}</p>
    <h2>{`でも、難しいんでしょう？`}</h2>
    <p>{`オペラの歌詞を理解するだけなら長期間の勉強は不要です。`}</p>
    <p>{`なぜなら、オペラの歌詞はすでに（そのほとんどは100年以上も前に）書かれていて、それを予習しておけばいいからです。`}</p>
    <p>{`ふつう語学というのは、あらゆる可能性に対応するためにあらかじめ膨大なボキャブラリーと文法体系をマスターしておかないと使い物になりません。`}</p>
    <p>{`でもオペラを理解する、というだけなら、そういうことは必要ありません。`}</p>
    <p>{`リスニングの試験とは違って、聞こえてくる音は最初からすべてわかっているのです！`}</p>
    <p>{`そして、3時間もあるオペラの台本を最初から最後まで予習する必要もありません。`}</p>
    <p>{`有名なアリアなど、「聴きどころ」と言われている部分だけ、つまみ食いする程度に予習しておけば十分に楽しめます。`}</p>
    <h2>{`まずは内容語に注目`}</h2>
    <p>{`オペラ好きな方の中には、言葉はわからなくても大体のあらすじは覚えているという方も多いかもしれません。`}</p>
    <p>{`アリアもなんとなく歌の意味は知っているという方もいるでしょう。`}</p>
    <p>{`そういう場合は、とりあえず意味のある単語だけ予習しておきましょう。`}</p>
    <p>{`意味のある単語というのは、名詞や動詞、形容詞などの、内容語と言われるものです。`}</p>
    <p>{`次の歌詞はヴェルディのラ・トラヴィアータ（椿姫）より。第 3 幕、ジェルモンからの手紙を読み終えた後に歌われるアリアです。`}</p>
    <p>{`Addio del passato bei sogni ridenti`}</p>
    <p>{`Le rose del volto già sono pallenti;`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`イタリア語`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`意味`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`addio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`さようなら`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`passato`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`過去`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`bei`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`美しい`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`sogni`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`夢`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ridenti`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`心地よい`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`rose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`バラ色`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`volto`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`頬`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`già`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`すでに`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pallenti`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`青白い`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`これだけで歌詞の意味がだいたいわかってしまいますよね。`}</p>
    <p>{`del や le といった小さな単語は無視していいのです。`}</p>
    <p>{`もちろん、イタリア語としてちゃんと理解しようと思ったら、時制やそれぞれの単語の係り受けなどを把握する必要があります。
それには、動詞の活用や前置詞の用法など、文法の知識が必要になります。`}</p>
    <p>{`でも、最初に言ったように、オペラの歌詞はもう決まっているので、わざわざ自分で今から分析しなくてもいいのです。`}</p>
    <p>{`日本語訳もありますから、それで全体の意味を理解し、重要な単語を少し覚えるだけで、オペラは十分原語で楽しめます！`}</p>
    <p>{`さらに歌詞のもっと隅々まで理解したい！ という欲望が生まれてきたら、本格的に語学の勉強を始めてみるのもいいでしょう。きっと世界が広がりますよ！`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      